import mvtMapStatic from '@/common/components/mvtmapstatic/mvt-mapstatic.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'propertyEstimateItem',
    props: {
        item: null,
        index: null,
        estPrice: null,
        isCurrent: {
            type: Boolean,
            default: false,
        },
        compareWithLand: {
            type: Boolean,
            default: false,
        },
    },
    inject: ['$eventBus'],
    components: {
        mvtMapStatic,
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        getIndex() {
            return this.index;
        },
    },
    methods: {
        openDpp() {
            location.href = this.item.dppUrl;
        },
        removeItem() {
            this.$emit('remove', this.getIndex);
        },
    },
};
